export * from "./interfaces";
// methods to implement:
// - GoogleMap.animateCamera
// - GoogleMap.snapshot
// - GoogleMap.setInfoWindowAdapter (HTMLElement)
// listeners to implement:
// - a lot
